// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import "./aquifer_ui/index"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AccordionToggleController from "./accordion_toggle_controller"
application.register("accordion-toggle", AccordionToggleController)

import AccordionDetailsA11yController from "./accordion_details_a11y_controller"
application.register("accordion-details-a11y", AccordionDetailsA11yController)

import ActivationWizardController from "./activation_wizard_controller"
application.register("activation-wizard", ActivationWizardController)

import AddItemsToCourseController from "./add_items_to_course_controller"
application.register("add-items-to-course", AddItemsToCourseController)

import AdminPreviewController from "./admin_preview_controller"
application.register("admin-preview", AdminPreviewController)

import AiAssistantChatController from "./ai_assistant_chat_controller"
application.register("ai-assistant-chat", AiAssistantChatController)

import AiAssistantFeedbackController from "./ai_assistant_feedback_controller"
application.register("ai-assistant-feedback", AiAssistantFeedbackController)

import AiAssistantPromptLockController from "./ai_assistant_prompt_lock_controller"
application.register("ai-assistant-prompt-lock", AiAssistantPromptLockController)

import AiAssistantSpeechToTextController from "./ai_assistant_speech_to_text_controller"
application.register("ai-assistant-speech-to-text", AiAssistantSpeechToTextController)

import AiAssistantStructuredOutputTypeController from "./ai_assistant_structured_output_type_controller"
application.register("ai-assistant-structured-output-type", AiAssistantStructuredOutputTypeController)

import AiAssistantTextInputController from "./ai_assistant_text_input_controller"
application.register("ai-assistant-text-input", AiAssistantTextInputController)

import AiAssistantThreadController from "./ai_assistant_thread_controller"
application.register("ai-assistant-thread", AiAssistantThreadController)

import AiAssistantVersionModalController from "./ai_assistant_version_modal_controller"
application.register("ai-assistant-version-modal", AiAssistantVersionModalController)

import AiChatAttachmentsController from "./ai_chat_attachments_controller"
application.register("ai-chat-attachments", AiChatAttachmentsController)

import AiChatRequireContentController from "./ai_chat_require_content_controller"
application.register("ai-chat-require-content", AiChatRequireContentController)

import AiMessageFeedbackController from "./ai_message_feedback_controller"
application.register("ai-message-feedback", AiMessageFeedbackController)

import AiMessagesScrollController from "./ai_messages_scroll_controller"
application.register("ai-messages-scroll", AiMessagesScrollController)

import AiPromptController from "./ai_prompt_controller"
application.register("ai-prompt", AiPromptController)

import AiSummaryFeedbackController from "./ai_summary_feedback_controller"
application.register("ai-summary-feedback", AiSummaryFeedbackController)

import AiVersionsController from "./ai_versions_controller"
application.register("ai-versions", AiVersionsController)

import ArchiveModalController from "./archive_modal_controller"
application.register("archive-modal", ArchiveModalController)

import AssessmentItemResponseSubmitController from "./assessment_item_response_submit_controller"
application.register("assessment-item-response-submit", AssessmentItemResponseSubmitController)

import AssessmentOfflineController from "./assessment_offline_controller"
application.register("assessment-offline", AssessmentOfflineController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BarGraphController from "./bar_graph_controller"
application.register("bar-graph", BarGraphController)

import BasketController from "./basket_controller"
application.register("basket", BasketController)

import BatchAddController from "./batch_add_controller"
application.register("batch-add", BatchAddController)

import ButtonActionController from "./button_action_controller"
application.register("button-action", ButtonActionController)

import CalibrateCurricularActionItemsCardController from "./calibrate_curricular_action_items_card_controller"
application.register("calibrate-curricular-action-items-card", CalibrateCurricularActionItemsCardController)

import CalibrateOrientationController from "./calibrate_orientation_controller"
application.register("calibrate-orientation", CalibrateOrientationController)

import CaseDropdownController from "./case_dropdown_controller"
application.register("case-dropdown", CaseDropdownController)

import CaseExperience__AiAssistantChatController from "./case_experience/ai_assistant_chat_controller"
application.register("case-experience--ai-assistant-chat", CaseExperience__AiAssistantChatController)

import CaseExperience__AiAssistantFeedbackController from "./case_experience/ai_assistant_feedback_controller"
application.register("case-experience--ai-assistant-feedback", CaseExperience__AiAssistantFeedbackController)

import CaseExperience__VtvChatController from "./case_experience/vtv_chat_controller"
application.register("case-experience--vtv-chat", CaseExperience__VtvChatController)

import CaseExperience__AiSummaryFeedbackController from "./case_experience/ai_summary_feedback_controller"
application.register("case-experience--ai-summary-feedback", CaseExperience__AiSummaryFeedbackController)

import CaseExperience__ButtonActionController from "./case_experience/button_action_controller"
application.register("case-experience--button-action", CaseExperience__ButtonActionController)

import CaseExperience__CasePreviewController from "./case_experience/case_preview_controller"
application.register("case-experience--case-preview", CaseExperience__CasePreviewController)

import CaseExperience__CaseViewerController from "./case_experience/case_viewer_controller"
application.register("case-experience--case-viewer", CaseExperience__CaseViewerController)

import CaseExperience__CategoryMatcherController from "./case_experience/category_matcher_controller"
application.register("case-experience--category-matcher", CaseExperience__CategoryMatcherController)

import CaseExperience__DiagnosesController from "./case_experience/diagnoses_controller"
application.register("case-experience--diagnoses", CaseExperience__DiagnosesController)

import CaseExperience__FeedbackCardController from "./case_experience/feedback_card_controller"
application.register("case-experience--feedback-card", CaseExperience__FeedbackCardController)

import CaseExperience__FindingsController from "./case_experience/findings_controller"
application.register("case-experience--findings", CaseExperience__FindingsController)

import CaseExperience__FinishCaseCardController from "./case_experience/finish_case_card_controller"
application.register("case-experience--finish-case-card", CaseExperience__FinishCaseCardController)

import CaseExperience__LearningObjectivesCompletionController from "./case_experience/learning_objectives_completion_controller"
application.register("case-experience--learning-objectives-completion", CaseExperience__LearningObjectivesCompletionController)

import CaseExperience__MultipleChoiceController from "./case_experience/multiple_choice_controller"
application.register("case-experience--multiple-choice", CaseExperience__MultipleChoiceController)

import CaseExperience__NotesController from "./case_experience/notes_controller"
application.register("case-experience--notes", CaseExperience__NotesController)

import CaseExperience__ProgressAnnouncerController from "./case_experience/progress_announcer_controller"
application.register("case-experience--progress-announcer", CaseExperience__ProgressAnnouncerController)

import CaseExperience__RatingBarController from "./case_experience/rating_bar_controller"
application.register("case-experience--rating-bar", CaseExperience__RatingBarController)

import CaseExperience__ResetCaseController from "./case_experience/reset_case_controller"
application.register("case-experience--reset-case", CaseExperience__ResetCaseController)

import CaseExperience__SectionCollapseController from "./case_experience/section_collapse_controller"
application.register("case-experience--section-collapse", CaseExperience__SectionCollapseController)

import CaseExperience__TodoButtonController from "./case_experience/todo_button_controller"
application.register("case-experience--todo-button", CaseExperience__TodoButtonController)

import CaseExperience__VpeErrorModalController from "./case_experience/vpe_error_modal_controller"
application.register("case-experience--vpe-error-modal", CaseExperience__VpeErrorModalController)

import CaseExperience__VpeFeedbackModalController from "./case_experience/vpe_feedback_modal_controller"
application.register("case-experience--vpe-feedback-modal", CaseExperience__VpeFeedbackModalController)

import CaseViewerController from "./case_viewer_controller"
application.register("case-viewer", CaseViewerController)

import CategoryMatcherController from "./category_matcher_controller"
application.register("category-matcher", CategoryMatcherController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CohortProgressesDeliveriesTableController from "./cohort_progresses_deliveries_table_controller"
application.register("cohort-progresses-deliveries-table", CohortProgressesDeliveriesTableController)

import CohortReportController from "./cohort_report_controller"
application.register("cohort-report", CohortReportController)

import ColumnSelectorController from "./column_selector_controller"
application.register("column-selector", ColumnSelectorController)

import ConcertinaController from "./concertina_controller"
application.register("concertina", ConcertinaController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import ContentLibraryModalController from "./content_library_modal_controller"
application.register("content-library-modal", ContentLibraryModalController)

import ContentSummaryController from "./content_summary_controller"
application.register("content-summary", ContentSummaryController)

import CopyBackupCodesController from "./copy_backup_codes_controller"
application.register("copy-backup-codes", CopyBackupCodesController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import CourseAddContentModalController from "./course_add_content_modal_controller"
application.register("course-add-content-modal", CourseAddContentModalController)

import CourseBuilderAiModalController from "./course_builder_ai_modal_controller"
application.register("course-builder-ai-modal", CourseBuilderAiModalController)

import CourseConfirmationModalController from "./course_confirmation_modal_controller"
application.register("course-confirmation-modal", CourseConfirmationModalController)

import CourseBuilderWizardController from "./course_builder_wizard_controller"
application.register("course-builder-wizard", CourseBuilderWizardController)

import CourseBuilderLeaveGuardController from "./course_builder_leave_guard_controller"
application.register("course-builder-leave-guard", CourseBuilderLeaveGuardController)

import CourseBuilderAddCaseController from "./course_builder_add_case_controller"
application.register("course-builder-add-case", CourseBuilderAddCaseController)

import CourseBuilderSettingsController from "./course_builder_settings_controller"
application.register("course-builder-settings", CourseBuilderSettingsController)

import CourseDuplicateModalController from "./course_duplicate_modal_controller"
application.register("course-duplicate-modal", CourseDuplicateModalController)

import CourseReportTotalsLoadingController from "./course_report_totals_loading_controller"
application.register("course-report-totals-loading", CourseReportTotalsLoadingController)

import CourseSelectorController from "./course_selector_controller"
application.register("course-selector", CourseSelectorController)

import CsrfFormSubmitController from "./csrf_form_submit_controller"
application.register("csrf-form-submit", CsrfFormSubmitController)

import CurrentUseSelectorController from "./current_use_selector_controller"
application.register("current-use-selector", CurrentUseSelectorController)

import CurricularSummaryTabController from "./curricular_summary_tab_controller"
application.register("curricular-summary-tab", CurricularSummaryTabController)

import CustomCourseNotificationsController from "./custom_course_notifications_controller"
application.register("custom-course-notifications", CustomCourseNotificationsController)

import Dashboard__CardContentController from "./dashboard/card_content_controller"
application.register("dashboard--card-content", Dashboard__CardContentController)

import Dashboard__Student__CaseLearningTimeChartController from "./dashboard/student/case_learning_time_chart_controller"
application.register("dashboard--student--case-learning-time-chart", Dashboard__Student__CaseLearningTimeChartController)

import Dashboard__Student__CompletedAvailableCasesChartController from "./dashboard/student/completed_available_cases_chart_controller"
application.register("dashboard--student--completed-available-cases-chart", Dashboard__Student__CompletedAvailableCasesChartController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DiagnosesController from "./diagnoses_controller"
application.register("diagnoses", DiagnosesController)

import DispatchEventController from "./dispatch_event_controller"
application.register("dispatch-event", DispatchEventController)

import DocumentModalController from "./document_modal_controller"
application.register("document-modal", DocumentModalController)

import DocumentRemovalController from "./document_removal_controller"
application.register("document-removal", DocumentRemovalController)

import DocumentShowController from "./document_show_controller"
application.register("document-show", DocumentShowController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditDeliveryController from "./edit_delivery_controller"
application.register("edit-delivery", EditDeliveryController)

import EducatorDashboardCardContentController from "./educator_dashboard_card_content_controller"
application.register("educator-dashboard-card-content", EducatorDashboardCardContentController)

import ElementCollapserController from "./element_collapser_controller"
application.register("element-collapser", ElementCollapserController)

import EmailNotificationsController from "./email_notifications_controller"
application.register("email-notifications", EmailNotificationsController)

import EnumSelectorController from "./enum_selector_controller"
application.register("enum-selector", EnumSelectorController)

import ExamCourseSchedulingController from "./exam_course_scheduling_controller"
application.register("exam-course-scheduling", ExamCourseSchedulingController)

import FeedbackCardModalController from "./feedback_card_modal_controller"
application.register("feedback-card-modal", FeedbackCardModalController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FetchDocumentsByMetadataController from "./fetch_documents_by_metadata_controller"
application.register("fetch-documents-by-metadata", FetchDocumentsByMetadataController)

import FilterAssessmentModalController from "./filter_assessment_modal_controller"
application.register("filter-assessment-modal", FilterAssessmentModalController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import FindingsController from "./findings_controller"
application.register("findings", FindingsController)

import FinishCaseCardController from "./finish_case_card_controller"
application.register("finish-case-card", FinishCaseCardController)

import FormErrorsFocusController from "./form_errors_focus_controller"
application.register("form-errors-focus", FormErrorsFocusController)

import GoalDateController from "./goal_date_controller"
application.register("goal-date", GoalDateController)

import GrduRequestQueueController from "./grdu_request_queue_controller"
application.register("grdu-request-queue", GrduRequestQueueController)

import GridListViewController from "./grid_list_view_controller"
application.register("grid-list-view", GridListViewController)

import GroupSelectionController from "./group_selection_controller"
application.register("group-selection", GroupSelectionController)

import HelpController from "./help_controller"
application.register("help", HelpController)

import HighlightFocusController from "./highlight_focus_controller"
application.register("highlight-focus", HighlightFocusController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImportNewQuestionsController from "./import_new_questions_controller"
application.register("import-new-questions", ImportNewQuestionsController)

import LinkKeyboardActivationController from "./link_keyboard_activation_controller"
application.register("link-keyboard-activation", LinkKeyboardActivationController)

import LoTpExportModalController from "./lo_tp_export_modal_controller"
application.register("lo-tp-export-modal", LoTpExportModalController)

import MfaSendOtpController from "./mfa_send_otp_controller"
application.register("mfa-send-otp", MfaSendOtpController)

import ModalAccessibilityController from "./modal_accessibility_controller"
application.register("modal-accessibility", ModalAccessibilityController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MountReactOnRailsController from "./mount_react_on_rails_controller"
application.register("mount-react-on-rails", MountReactOnRailsController)

import MultiCohortCurricularSummaryTabController from "./multi_cohort_curricular_summary_tab_controller"
application.register("multi-cohort-curricular-summary-tab", MultiCohortCurricularSummaryTabController)

import MultipleChoiceController from "./multiple_choice_controller"
application.register("multiple-choice", MultipleChoiceController)

import NestedDropdownController from "./nested_dropdown_controller"
application.register("nested-dropdown", NestedDropdownController)

import NewDeliveryController from "./new_delivery_controller"
application.register("new-delivery", NewDeliveryController)

import NewExamVariationController from "./new_exam_variation_controller"
application.register("new-exam-variation", NewExamVariationController)

import NewProjectController from "./new_project_controller"
application.register("new-project", NewProjectController)

import NodesImageGalleryController from "./nodes_image_gallery_controller"
application.register("nodes-image-gallery", NodesImageGalleryController)

import NotesController from "./notes_controller"
application.register("notes", NotesController)

import NotifyProgramController from "./notify_program_controller"
application.register("notify-program", NotifyProgramController)

import OfflineNavigationController from "./offline_navigation_controller"
application.register("offline-navigation", OfflineNavigationController)

import OfflineWipeController from "./offline_wipe_controller"
application.register("offline-wipe", OfflineWipeController)

import OpenQuestionsController from "./open_questions_controller"
application.register("open-questions", OpenQuestionsController)

import OpenReactModalController from "./open_react_modal_controller"
application.register("open-react-modal", OpenReactModalController)

import OverflowDetectorController from "./overflow_detector_controller"
application.register("overflow-detector", OverflowDetectorController)

import OverlayController from "./overlay_controller"
application.register("overlay", OverlayController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import PracticeSmartFormEditController from "./practice_smart_form_edit_controller"
application.register("practice-smart-form-edit", PracticeSmartFormEditController)

import PrintDocumentController from "./print_document_controller"
application.register("print-document", PrintDocumentController)

import ProfileMenuController from "./profile_menu_controller"
application.register("profile-menu", ProfileMenuController)

import ProgressTrackerController from "./progress_tracker_controller"
application.register("progress-tracker", ProgressTrackerController)

import ProjectDashboardController from "./project_dashboard_controller"
application.register("project-dashboard", ProjectDashboardController)

import ProjectsReportsController from "./projects_reports_controller"
application.register("projects-reports", ProjectsReportsController)

import PsReportAccessibilityController from "./ps_report_accessibility_controller"
application.register("ps-report-accessibility", PsReportAccessibilityController)

import PsReportFilterController from "./ps_report_filter_controller"
application.register("ps-report-filter", PsReportFilterController)

import PushNotificationPromptController from "./push_notification_prompt_controller"
application.register("push-notification-prompt", PushNotificationPromptController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import PwaInstallPromptController from "./pwa_install_prompt_controller"
application.register("pwa-install-prompt", PwaInstallPromptController)

import QuestionStatsController from "./question_stats_controller"
application.register("question-stats", QuestionStatsController)

import QuizFormController from "./quiz_form_controller"
application.register("quiz-form", QuizFormController)

import QuizHoverController from "./quiz_hover_controller"
application.register("quiz-hover", QuizHoverController)

import QuizLaunchOfflineController from "./quiz_launch_offline_controller"
application.register("quiz-launch-offline", QuizLaunchOfflineController)

import QuizModalController from "./quiz_modal_controller"
application.register("quiz-modal", QuizModalController)

import QuizModeController from "./quiz_mode_controller"
application.register("quiz-mode", QuizModeController)

import QuizOfflineController from "./quiz_offline_controller"
application.register("quiz-offline", QuizOfflineController)

import SyncStatusController from "./sync_status_controller"
application.register("sync-status", SyncStatusController)

import PwaResumeController from "./pwa_resume_controller"
application.register("pwa-resume", PwaResumeController)

import QuizPlayerAuxController from "./quiz_player_aux_controller"
application.register("quiz-player-aux", QuizPlayerAuxController)

import RatingBarController from "./rating_bar_controller"
application.register("rating-bar", RatingBarController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import ReducibleListController from "./reducible_list_controller"
application.register("reducible-list", ReducibleListController)

import RelatedQuestionsModalController from "./related_questions_modal_controller"
application.register("related-questions-modal", RelatedQuestionsModalController)

import ReportDateRangesController from "./report_date_ranges_controller"
application.register("report-date-ranges", ReportDateRangesController)

import ReportFilterController from "./report_filter_controller"
application.register("report-filter", ReportFilterController)

import ReportsDashboardController from "./reports_dashboard_controller"
application.register("reports-dashboard", ReportsDashboardController)

import ReportsSelectController from "./reports_select_controller"
application.register("reports-select", ReportsSelectController)

import ResetCaseController from "./reset_case_controller"
application.register("reset-case", ResetCaseController)
import ClearLocalCaseProgressController from "./clear_local_case_progress_controller"
application.register("clear-local-case-progress", ClearLocalCaseProgressController)

import ResetPopupConfirmationController from "./reset_popup_confirmation_controller"
application.register("reset-popup-confirmation", ResetPopupConfirmationController)

import RowOrderingController from "./row_ordering_controller"
application.register("row-ordering", RowOrderingController)

import RowSelectorController from "./row_selector_controller"
application.register("row-selector", RowSelectorController)

import SaqController from "./saq_controller"
application.register("saq", SaqController)

import SccSelectionController from "./scc_selection_controller"
application.register("scc-selection", SccSelectionController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SectionCollapseController from "./section_collapse_controller"
application.register("section-collapse", SectionCollapseController)

import SelectAllCheckboxController from "./select_all_checkbox_controller"
application.register("select-all-checkbox", SelectAllCheckboxController)

import SelectCaseModalController from "./select_case_modal_controller"
application.register("select-case-modal", SelectCaseModalController)

import SelectCourseModalController from "./select_course_modal_controller"
application.register("select-course-modal", SelectCourseModalController)

import SelectStudentModalController from "./select_student_modal_controller"
application.register("select-student-modal", SelectStudentModalController)

import SessionsController from "./sessions_controller"
application.register("sessions", SessionsController)

import ShareReportModalController from "./share_report_modal_controller"
application.register("share-report-modal", ShareReportModalController)

import SideNavigationPageController from "./side_navigation_page_controller"
application.register("side-navigation-page", SideNavigationPageController)

import SingleCohortReportController from "./single_cohort_report_controller"
application.register("single-cohort-report", SingleCohortReportController)

import SlideRightController from "./slide_right_controller"
application.register("slide-right", SlideRightController)

import SortColumnsController from "./sort_columns_controller"
application.register("sort-columns", SortColumnsController)

import SpeechToTextController from "./speech_to_text_controller"
application.register("speech-to-text", SpeechToTextController)

import SsmOptoutController from "./ssm_optout_controller"
application.register("ssm-optout", SsmOptoutController)

import StickyInfoController from "./sticky_info_controller"
application.register("sticky-info", StickyInfoController)

import StudentActivityLogExportController from "./student_activity_log_export_controller"
application.register("student-activity-log-export", StudentActivityLogExportController)

import StudentChoiceCasesController from "./student_choice_cases_controller"
application.register("student-choice-cases", StudentChoiceCasesController)

import StudentLearningProgressTableController from "./student_learning_progress_table_controller"
application.register("student-learning-progress-table", StudentLearningProgressTableController)

import StudentPerformanceController from "./student_performance_controller"
application.register("student-performance", StudentPerformanceController)

import StudentReportTabsController from "./student_report_tabs_controller"
application.register("student-report-tabs", StudentReportTabsController)

import SuccessBannerController from "./success_banner_controller"
application.register("success-banner", SuccessBannerController)

import SurveyFormController from "./survey_form_controller"
application.register("survey-form", SurveyFormController)

import SwUpdateController from "./sw_update_controller"
application.register("sw-update", SwUpdateController)

import SwitchAccessibleController from "./switch_accessible_controller"
application.register("switch-accessible", SwitchAccessibleController)

import SyncFrameController from "./sync_frame_controller"
application.register("sync-frame", SyncFrameController)

import TextDecorationController from "./text_decoration_controller"
application.register("text-decoration", TextDecorationController)

import ToDoModalController from "./to_do_modal_controller"
application.register("to-do-modal", ToDoModalController)

import TodoButtonController from "./todo_button_controller"
application.register("todo-button", TodoButtonController)

import TodoFormController from "./todo_form_controller"
application.register("todo-form", TodoFormController)

import TodoListPageController from "./todo_list_page_controller"
application.register("todo-list-page", TodoListPageController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboRequestController from "./turbo_request_controller"
application.register("turbo-request", TurboRequestController)

import UpdateUserProfileController from "./update_user_profile_controller"
application.register("update-user-profile", UpdateUserProfileController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)

import WizardCurrentUsersSelectController from "./wizard_current_users_select_controller"
application.register("wizard-current-users-select", WizardCurrentUsersSelectController)
